<template>
  <base-modal
    :confirmEnabled="true"
    :customShowDialog="showShareModal"
    @confirmed="$emit('confirmed')"
    @close="handleClose"
    :title="$t('modal.share.title')"
    :confirmButton="$t('modal.share.confirmBtn')"
  >
    <div slot="body" class="modal-text">
      <span>{{ $t('modal.share.subtitle') }}</span><br/>
      <span @click="$emit('confirmed')" style="cursor:pointer;"><u>{{ shareUrl }}</u><v-icon>content_copy</v-icon></span>
    </div>
  </base-modal>
</template>

<script>
export default {
  name: 'share-modal',
  props: ['shareUrl'],
  components: {
    BaseModal: () => import('./BaseModal')
  },
  computed: {
    showShareModal: { get () { return this.$store.state.modalState.showShareModal } }
  },
  methods: {
    handleClose () {
      this.$store.commit('setShowShareModal', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ShareModal.vue